import { Form, Select, FormInstance } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { TicketData } from "../../../models/event";

const Tickets = ({
  label = "Ticket",
  name = "ticket",
}: {
  name?: string;
  label?: string;
  form: FormInstance;
}) => {
  const event = useSelector((state: RootState) => state.event);

  return (
    <>
      <Form.Item
        name={name}
        label={label}
        rules={[
          {
            required: true,
            message: "This field is required",
          },
        ]}
      >
        <Select
          showSearch
          mode="multiple"
          options={event?.tickets?.map((data: TicketData) => ({
            label: data?.name,
            value: data?.id,
          }))}
          optionFilterProp="label"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
      </Form.Item>
    </>
  );
};

export default Tickets;
